import * as Icons from 'lucide-react';
import { SECURITY } from '../../config/site';
import { SectionHeader } from '../common';

export default function SecuritySection() {
  return (
    <section className="section">
      <div className="container-x">
        <div className="reveal"><SectionHeader eyebrow="Security" title="Built around control, security and accountability." sub="Institutional discipline extends to how your access, accounts and activity are protected." /></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {SECURITY.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Shield;
            return (
              <div key={s.title} className="panel panel-hover p-6 reveal" style={{ transitionDelay: `${(i % 3) * 60}ms` }}>
                <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{ background: 'var(--gold-soft)', border: '1px solid var(--gold-border)' }}><Icon size={20} className="text-[var(--gold-2)]" /></div>
                <h3 className="font-display text-[16.5px] font-bold text-white">{s.title}</h3>
                <p className="text-[13.5px] text-[var(--muted)] mt-2 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
